// extracted by mini-css-extract-plugin
module.exports = {"Package":"XnC5BFFurv0Qdqf_AANov"};